export default {"src":"/_next/static/media/homepage-gray-icon.88db9ba9.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};